import { MenuItem } from '@mui/material'
import { SkipStepTaskDialogV2 } from 'components/pages/task/details/task-content-v2/common/SkipStepTaskDialogV2'
import { TaskValue } from 'lib/actions/task'
import { useSimpleModal } from 'lib/modals'
import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'

type SkipStepDropdownOptionProps = {
    task: TaskValue
    close: () => void
}

export const SkipStepDropdownOption: FC<SkipStepDropdownOptionProps> = ({ task, close }) => {
    const { open } = useSimpleModal()
    const handleClick = (): void => {
        open(SkipStepTaskDialogV2, { task })()
        close()
    }

    return (
        <MenuItem onClick={handleClick} key={`components_task_actions_dropdown_skip_step_${task.id}`}>
            <FormattedMessage id="components_task_actions_dropdown_skip_step" defaultMessage="Skip step" />
        </MenuItem>
    )
}
